export default __webpack_public_path__ + "static/media/Gene, Edith and Ralph 1925.202ce347.jpg";